module.exports = __webpack_public_path__ + "img/svg/divider-short.6f4012817f0444f65ca754c8193aa00b.svg";